export interface SessionPanelist {
  id: string;
  name: string;
  role: string;
  organization: string;
  imageSrc: string;
}

export interface AgendaSession {
  id: string;
  day: 1 | 2;
  date: string; // '2027-07-27' | '2027-07-28'
  dateLabel: string; // 'Tuesday, 27 July 2027'
  timeSlot: string; // '10:00 AM - 10:45 AM'
  startTime: string; // '10:00'
  endTime: string; // '10:45'
  hall: string; // 'Main Plenary Hall'
  track: string;
  title: string;
  format: 'keynote' | 'panel';
  abstract?: string;
  speaker?: {
    id: string;
    name: string;
    designation: string;
    organization: string;
    imageSrc?: string | null;
    linkedinUrl?: string;
  };
  moderator?: {
    id: string;
    name: string;
    designation: string;
    organization: string;
    imageSrc?: string | null;
    linkedinUrl?: string;
  };
  panelists?: SessionPanelist[];
}

export const agendaSessions: AgendaSession[] = [
  // ==========================================
  // DAY 1 (Tuesday, 27 July 2027)
  // ==========================================
  {
    id: 'session-d1-01',
    day: 1,
    date: '2027-07-27',
    dateLabel: 'Tuesday, 27 July 2027',
    timeSlot: '10:00 AM - 10:45 AM',
    startTime: '10:00',
    endTime: '10:45',
    hall: 'Main Plenary Hall',
    track: 'Policy & Global Trade',
    title: 'National Blueprint for Agritech Innovation & Global Agri-Exports',
    format: 'keynote',
    abstract: 'High-level ministerial plenary outlining public-private frameworks, regulatory harmonization for agricultural drones, and bio-economy trade.',
    speaker: {
      id: '77777777-1111-1111-1111-000000000001',
      name: 'Dr. Ramesh Chand',
      designation: 'Union Policy Member (Agriculture)',
      organization: 'NITI Aayog (Govt of India)',
      imageSrc: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300',
      linkedinUrl: 'https://linkedin.com/in/dr-ramesh-chand-niti',
    },
  },
  {
    id: 'session-d1-02',
    day: 1,
    date: '2027-07-27',
    dateLabel: 'Tuesday, 27 July 2027',
    timeSlot: '11:15 AM - 12:15 PM',
    startTime: '11:15',
    endTime: '12:15',
    hall: 'Main Plenary Hall',
    track: 'Biologicals & Biofertilizers',
    title: 'Climate-Resilient Agriculture & Indigenous Bio-Stimulants',
    format: 'panel',
    abstract: 'Scientific and commercial panel assessing field validation, microbial consortia efficacy, and reducing chemical load across cropping zones.',
    moderator: {
      id: '77777777-1111-1111-1111-000000000002',
      name: 'Dr. Himanshu Pathak',
      designation: 'Director General & Secretary (DARE)',
      organization: 'ICAR (Indian Council of Agricultural Research)',
      imageSrc: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300',
      linkedinUrl: 'https://linkedin.com/in/dr-himanshu-pathak-icar',
    },
    panelists: [
      {
        id: 'dr-krk-reddy',
        name: 'Dr. KRK Reddy',
        role: 'Managing Director',
        organization: 'Sri BioAesthetics Pvt Ltd',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/krk-reddy-1747382318.png',
      },
      {
        id: 'bakulchandra-joshi',
        name: 'Bakulchandra Joshi',
        role: 'President & COO',
        organization: 'T.Stanes & Company Ltd',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/bakulchandra-joshi-1782713299.jpg',
      },
      {
        id: 'dr-rahul-mirchandani',
        name: 'Dr. Rahul Mirchandani',
        role: 'Chairman & MD',
        organization: 'Aries Agro Ltd',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/rahul-mirchandani-1782713733.jpg',
      },
    ],
  },
  {
    id: 'session-d1-03',
    day: 1,
    date: '2027-07-27',
    dateLabel: 'Tuesday, 27 July 2027',
    timeSlot: '02:00 PM - 02:45 PM',
    startTime: '14:00',
    endTime: '14:45',
    hall: 'Conference Hall 1',
    track: 'Agritech & AI',
    title: 'Hyperlocal AI & Satellite Imagery in Smallholder Farm Underwriting',
    format: 'keynote',
    abstract: 'Architectural breakdown of deploying multimodal vision transformers and soil sensor fusion to predict harvest yields and automate credit.',
    speaker: {
      id: '77777777-1111-1111-1111-000000000003',
      name: 'Shashank Kumar',
      designation: 'Co-Founder & CEO',
      organization: 'DeHaat Agri Revolution',
      imageSrc: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=300',
      linkedinUrl: 'https://linkedin.com/in/shashank-kumar-dehaat',
    },
  },
  {
    id: 'session-d1-04',
    day: 1,
    date: '2027-07-27',
    dateLabel: 'Tuesday, 27 July 2027',
    timeSlot: '03:15 PM - 04:15 PM',
    startTime: '15:15',
    endTime: '16:15',
    hall: 'Conference Hall 2',
    track: 'Agrochemicals & Crop Protection',
    title: 'Next-Gen Drone Micro-Emulsions & Green Formulation Chemistry',
    format: 'panel',
    abstract: 'Addressing drift reduction, surface tension optimization, and eco-toxicology compliance in automated commercial UAV spraying.',
    moderator: {
      id: 'prasad-chandran',
      name: 'Prasad Chandran',
      designation: 'Former Chairman & MD',
      organization: 'BASF India & South Asia',
      imageSrc: 'https://iiabexpo.com/uploads/speakers/prasad-chandran-1782372524.jpg',
    },
    panelists: [
      {
        id: 'atul-churiwal',
        name: 'Atul Churiwal',
        role: 'Managing Director',
        organization: 'Krishi Rasayan Exports',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/atul-churiwal-1782713289.jpg',
      },
      {
        id: 'rajvir-singh-rathi',
        name: 'Rajvir Singh Rathi',
        role: 'VP Public Affairs & Science',
        organization: 'Bayer CropScience',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/rajvir-singh-rathi-1782713581.jpg',
      },
      {
        id: 'abhijeet-bose',
        name: 'Abhijeet Bose',
        role: 'Executive President & COO',
        organization: 'Tagros Chemicals India',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/abhijeet-bose-1782713451.jpg',
      },
    ],
  },

  // ==========================================
  // DAY 2 (Wednesday, 28 July 2027)
  // ==========================================
  {
    id: 'session-d2-01',
    day: 2,
    date: '2027-07-28',
    dateLabel: 'Wednesday, 28 July 2027',
    timeSlot: '10:00 AM - 10:45 AM',
    startTime: '10:00',
    endTime: '10:45',
    hall: 'Technical Breakout A',
    track: 'Biologicals & Biofertilizers',
    title: 'Soil Microbiome Regeneration & Bio-Safety Active Ingredients',
    format: 'keynote',
    abstract: 'Dual-mode crop protection where mycorrhizae consortia operate synergistically with targeted, low-toxicity chemical formulations.',
    speaker: {
      id: '77777777-1111-1111-1111-000000000005',
      name: 'Anand Deshmukh',
      designation: 'Director of Sustainable Outreach & Carbon Farming',
      organization: 'UPL Global Sustainable Agri',
      imageSrc: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300',
      linkedinUrl: 'https://linkedin.com/in/anand-deshmukh-upl',
    },
  },
  {
    id: 'session-d2-02',
    day: 2,
    date: '2027-07-28',
    dateLabel: 'Wednesday, 28 July 2027',
    timeSlot: '11:15 AM - 12:15 PM',
    startTime: '11:15',
    endTime: '12:15',
    hall: 'Technical Breakout B',
    track: 'Cold Chain & Agri-Logistics',
    title: 'Solar Micro-Cold Rooms & Farm-Gate Perishables Preservation',
    format: 'panel',
    abstract: 'Bridging the 30% perishables loss gap through distributed off-grid cooling modules, IoT temperature telemetry, and integrated reefer logistics.',
    moderator: {
      id: '77777777-1111-1111-1111-000000000006',
      name: 'Siddharth Jain',
      designation: 'Chief Marketing Officer',
      organization: 'Jain Irrigation Systems Ltd',
      imageSrc: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300',
      linkedinUrl: 'https://linkedin.com/in/siddharth-jain-irrigation',
    },
    panelists: [
      {
        id: 'prasad-chandran',
        name: 'Prasad Chandran',
        role: 'Former Chairman & MD',
        organization: 'BASF India & South Asia',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/prasad-chandran-1782372524.jpg',
      },
      {
        id: 'bakulchandra-joshi',
        name: 'Bakulchandra Joshi',
        role: 'President & COO',
        organization: 'T.Stanes & Company Ltd',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/bakulchandra-joshi-1782713299.jpg',
      },
      {
        id: 'dr-rahul-mirchandani',
        name: 'Dr. Rahul Mirchandani',
        role: 'Chairman & MD',
        organization: 'Aries Agro Ltd',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/rahul-mirchandani-1782713733.jpg',
      },
    ],
  },
  {
    id: 'session-d2-03',
    day: 2,
    date: '2027-07-28',
    dateLabel: 'Wednesday, 28 July 2027',
    timeSlot: '02:00 PM - 02:45 PM',
    startTime: '14:00',
    endTime: '14:45',
    hall: 'Exhibition Presentation Stage',
    track: 'Agritech & AI',
    title: 'Autonomous Field Robotics & Heavy Machinery Electrification',
    format: 'keynote',
    abstract: 'Live technical review of optical weed differentiation and battery-swapping architecture engineered for continuous 24-hr tillage.',
    speaker: {
      id: '77777777-1111-1111-1111-000000000007',
      name: 'Vikramaditya Singhania',
      designation: 'Managing Director & Founder',
      organization: 'AgriHorizon Robotics Pvt Ltd',
      imageSrc: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=300',
      linkedinUrl: 'https://linkedin.com/in/vikram-singhania-robotics',
    },
  },
  {
    id: 'session-d2-04',
    day: 2,
    date: '2027-07-28',
    dateLabel: 'Wednesday, 28 July 2027',
    timeSlot: '03:15 PM - 04:15 PM',
    startTime: '15:15',
    endTime: '16:15',
    hall: 'Conference Hall 1',
    track: 'Agrochemicals & Global Trade',
    title: 'Expanding Indian Agrochemical Exports: Standards & Tariffs',
    format: 'panel',
    abstract: 'Navigating maximum residue limits (MRLs), EU Green Deal compliance, and accelerating export registration in LatAm and ASEAN markets.',
    moderator: {
      id: 'ankur-aggarwal',
      name: 'Ankur Aggarwal',
      designation: 'Executive Chairman & MD',
      organization: 'Crystal Crop Protection',
      imageSrc: 'https://iiabexpo.com/uploads/speakers/ankur-aggarwal-1782132907.jpg',
    },
    panelists: [
      {
        id: 'abhijeet-bose',
        name: 'Abhijeet Bose',
        role: 'Executive President & COO',
        organization: 'Tagros Chemicals India',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/abhijeet-bose-1782713451.jpg',
      },
      {
        id: 'atul-churiwal',
        name: 'Atul Churiwal',
        role: 'Managing Director',
        organization: 'Krishi Rasayan Exports',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/atul-churiwal-1782713289.jpg',
      },
      {
        id: 'rajvir-singh-rathi',
        name: 'Rajvir Singh Rathi',
        role: 'VP Public Affairs & Science',
        organization: 'Bayer CropScience',
        imageSrc: 'https://iiabexpo.com/uploads/speakers/rajvir-singh-rathi-1782713581.jpg',
      },
    ],
  },
];

export function buildDynamicAgendaSessions(dbSpeakers: any[] = []): AgendaSession[] {
  const existingSpeakerIds = new Set<string>();
  const existingSpeakerNames = new Set<string>();

  for (const s of agendaSessions) {
    if (s.speaker?.id) existingSpeakerIds.add(s.speaker.id);
    if (s.speaker?.name) existingSpeakerNames.add(s.speaker.name.toLowerCase());
    if (s.moderator?.id) existingSpeakerIds.add(s.moderator.id);
    if (s.moderator?.name) existingSpeakerNames.add(s.moderator.name.toLowerCase());
  }

  const dynamicSessions: AgendaSession[] = [];
  for (const spk of dbSpeakers || []) {
    if (!spk || !spk.fullName) continue;
    if (
      existingSpeakerIds.has(spk.id) ||
      existingSpeakerNames.has(String(spk.fullName).toLowerCase())
    ) {
      continue;
    }

    const isDay2 = String(spk.sessionDate || '').includes('28') || String(spk.sessionDate || '').toLowerCase().includes('day 2');
    const day: 1 | 2 = isDay2 ? 2 : 1;
    const date = isDay2 ? '2027-07-28' : '2027-07-27';
    const dateLabel = isDay2 ? 'Wednesday, 28 July 2027' : 'Tuesday, 27 July 2027';
    const startTime = spk.sessionStartTime || '12:15';
    const endTime = spk.sessionEndTime || '13:00';
    const timeSlot = spk.sessionStartTime
      ? `${spk.sessionStartTime}${spk.sessionEndTime ? ` - ${spk.sessionEndTime}` : ''}`
      : '12:15 PM - 01:00 PM';

    dynamicSessions.push({
      id: `spk-${spk.id}`,
      day,
      date,
      dateLabel,
      timeSlot,
      startTime,
      endTime,
      hall: spk.stageOrHall || 'Conference Hall 1 (128 PAX)',
      track: spk.track || 'Agri-Business & Innovation',
      title: spk.topicTitle || 'Featured Keynote Session',
      format: 'keynote',
      abstract: spk.topicAbstract || spk.bio || undefined,
      speaker: {
        id: spk.id,
        name: spk.fullName,
        designation: spk.designation || 'Keynote Speaker',
        organization: spk.organization || 'IIAB 2027',
        imageSrc: spk.headshotUrl || null,
        linkedinUrl: spk.linkedinUrl || undefined,
      },
    });
  }

  return [...agendaSessions, ...dynamicSessions].sort((a, b) =>
    a.startTime.localeCompare(b.startTime)
  );
}

